"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function iotx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M13.8915 3.49573V7.58848L17.445 5.54473L13.8915 3.49573Z", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M17.445 5.54468V9.63743L20.9978 7.58843L17.445 5.54468Z", fill: color }),
        React.createElement("path", { opacity: 0.8, d: "M13.8915 7.5885V11.6813L17.445 9.6375L13.8915 7.5885ZM17.445 9.63825V13.7303L20.9977 11.6813L17.445 9.63825Z", fill: color }),
        React.createElement("path", { opacity: 0.8, d: "M13.8915 11.6813V15.774L17.445 13.7303L13.8915 11.6813Z", fill: color }),
        React.createElement("path", { d: "M17.445 13.7302V17.823L20.9978 15.774L17.445 13.7302Z", fill: color }),
        React.createElement("path", { opacity: 0.4, d: "M4.70703 7.45044V11.5432L8.26053 9.49419L4.70703 7.45044Z", fill: color }),
        React.createElement("path", { opacity: 0.2, d: "M9.18976 8.97217V13.0649L12.7373 11.0212L9.18976 8.97217Z", fill: color }),
        React.createElement("path", { opacity: 0.3, d: "M6.55573 11.5604V15.6532L10.1085 13.6042L6.55573 11.5604Z", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M8.89722 14.6489V18.7417L12.4447 16.6927L8.89722 14.6489Z", fill: color }),
        React.createElement("path", { opacity: 0.7, d: "M13.8622 16.4108V20.5043L17.4097 18.4545L13.8622 16.4108Z", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M9.78149 6.95093V11.0444L13.329 9.00068L9.78149 6.95093Z", fill: color }),
        React.createElement("path", { opacity: 0.8, d: "M13.8915 3.49573V7.58848L10.338 5.54473L13.8915 3.49573Z", fill: color }),
        React.createElement("path", { opacity: 0.6, d: "M9.78148 5.23572V9.32772L6.22723 7.27872L9.78148 5.23572Z", fill: color }),
        React.createElement("path", { opacity: 0.6, d: "M13.335 7.26074V11.3542L9.78149 9.30449L13.335 7.26074Z", fill: color }),
        React.createElement("path", { opacity: 0.95, d: "M9.17325 8.97217V13.0649L5.61975 11.0212L9.17325 8.97217Z", fill: color }),
        React.createElement("path", { opacity: 0.6, d: "M13.8915 11.6813V15.774L10.344 13.7303L13.8915 11.6813Z", fill: color }),
        React.createElement("path", { opacity: 0.55, d: "M6.55576 12.6345V16.7273L3.00226 14.6775L6.55576 12.6345Z", fill: color }),
        React.createElement("path", { d: "M20.9978 7.5885V11.6813L17.445 9.6375L20.9978 7.5885Z", fill: color }),
        React.createElement("path", { opacity: 0.95, d: "M17.445 9.63818V13.7302L13.8915 11.6812L17.445 9.63818Z", fill: color }),
        React.createElement("path", { opacity: 0.9, d: "M20.9978 11.6813V15.774L17.445 13.7303L20.9978 11.6813Z", fill: color }),
        React.createElement("path", { opacity: 0.7, d: "M17.445 13.7302V17.823L13.8915 15.774L17.445 13.7302Z", fill: color }),
        React.createElement("path", { opacity: 0.4, d: "M13.1048 15.4358V19.5285L9.55206 17.4848L13.1048 15.4358Z", fill: color }),
        React.createElement("path", { d: "M17.445 5.54468V9.63743L13.8915 7.58843L17.445 5.54468Z", fill: color }));
}
exports["default"] = iotx;
//# sourceMappingURL=iotx.js.map